"use client";

import { Core } from "@faire/design-tokens";
import React from "react";

import { createSVGIcon } from "../util";

/**
 * @figma designed by Gabe Kelley, Nick Howland (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=5414%3A954))
 * @trackcomponent
 * @lastsynced 2025-04-16T17:02:15.963Z
 * @optimized using svgo:^3.0.2
 */
export const ClockSolid = createSVGIcon(
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M12 23c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11m.982-14.929a.982.982 0 1 0-1.964 0V12c0 .23.08.452.227.629l3.93 4.714a.982.982 0 1 0 1.508-1.258l-3.7-4.44z"
    fill="currentColor"
    clipPath="url(#clip0_5414_954)"
  />,
  "ClockSolid",
  { color: Core.icon.default, fill: "none", viewBox: "0 0 24 24" } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
